import { CheckCircle2 } from "lucide-react";

// Mirrors src/app/pricing/page.tsx `included` array — single source of truth
// for the "Everything's included" feature list across homepage + /pricing.
export const INCLUDED_FEATURES = [
  "AI-powered reply generation",
  "Email & mobile notifications",
  "One-tap approve, edit, or skip",
  "Multi-language replies",
  "Dashboard & analytics",
  "Priority email support",
  "Multi-location management",
  "Monthly cancel-anytime option",
];

type Props = {
  items?: string[];
  className?: string;
  iconClassName?: string;
};

export default function FeatureList({
  items = INCLUDED_FEATURES,
  className = "",
  iconClassName = "text-accent-600",
}: Props) {
  return (
    <ul className={`space-y-2.5 text-sm text-ink-700 ${className}`}>
      {items.map((item) => (
        <li key={item} className="flex items-start gap-2.5">
          <CheckCircle2
            className={`mt-0.5 h-4 w-4 shrink-0 ${iconClassName}`}
            aria-hidden="true"
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
